import script from "./WoononExtraProductMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./WoononExtraProductMobile.vue?vue&type=script&lang=ts&setup=true"

import "./WoononExtraProductMobile.vue?vue&type=style&index=0&id=4586539d&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4586539d"]])

export default __exports__